import React, { useState } from 'react';
import {
    Typography, makeStyles, Button, Dialog, DialogContent,
    DialogActions, TextField as MuiTextField, CircularProgress, IconButton, InputAdornment
} from '@material-ui/core';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import md5 from 'md5';
import { passwordSalt } from "../sharedData";
import VisibilityIcon from '@material-ui/icons/Visibility';
import config from "../config.json";
import { saveTokens } from '../utils/saveTokens';
import notify from './CustomUseNotify';

const useStyles = makeStyles({
    dialogPaper: {
        borderRadius: 15,
        padding: "5px 15px 15px",
        maxWidth: 350
    },
    dialogButton: {
        borderRadius: 100,
        padding: "8px 25px"
    },
    dialogPaperBig: {
        borderRadius: 15,
        padding: "5px 5px 10px",
    },
    input: {
        width: "500px"
    }
});

function PrivacyPasswordAuthentication({ privacyFeatureAccess, setPrivacyFeatureAccess }) {
    const classes = useStyles()
    const [dialogVisible, setDialogVisible] = React.useState(false);
    const [privacyPassword, setPrivacyPassword] = useState("");
    const [showPrivacyPassword, setShowPrivacyPassword] = useState(false);
    const [loading, setLoading] = useState(false)

    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };

    const authenticate = () => {

        if (privacyPassword == null || privacyPassword === "") {
            notify("Privacy Password cannot be empty", "warning");
            return;
        }

        let params = {
            privacy_password: md5(privacyPassword + passwordSalt)
        }

        setLoading(true)
        fetch(`${config.HOST_NAME}/crm/v3/privacypassword/authentication`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify(params)
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    notify(json.message, "success");
                    sessionStorage.setItem('privacy_feature_access', json.data.authorize);
                    setPrivacyFeatureAccess(true)
                    setLoading(false)
                    setPrivacyPassword("")
                    closeDialog()
                } else {
                    notify(json.message, "warning");
                    setLoading(false)
                }
            })
            .catch((error) => {
                setLoading(false);
                notify("Something Went Wrong", "warning");
            });
    }

    return <div>
        {
            privacyFeatureAccess ?
                <Button className='buttonStyle addBorderRadius' title='Hide Mobile No.' variant='contained' color="secondary" disableElevation size="small" 
                    onClick={() => {
                        setPrivacyFeatureAccess(false)
                        sessionStorage.setItem('privacy_feature_access', "0")
                    }}>
                    <VisibilityOffIcon style={{ fontSize: "20px" }} />
                </Button>
                :
                <Button className='buttonStyle addBorderRadius' title='Show Mobile No.' variant='contained' color="secondary" disableElevation size="small" onClick={openDialog}>
                    <VisibilityIcon style={{ fontSize: "20px" }} />
                </Button>
        }

        <Dialog fullWidth open={dialogVisible} onClose={closeDialog} classes={{ paper: classes.dialogPaperBig }}>
            <DialogContent>
                <Typography style={{ fontSize: 14, fontWeight: "600" }}>Please enter your Privacy Password</Typography>
                <MuiTextField
                    className='changePasswordTextField'
                    type={showPrivacyPassword ? "text" : "password"}
                    variant="outlined"
                    size="small"
                    label="Privacy Password"
                    value={privacyPassword}
                    onChange={event => setPrivacyPassword(event.target.value)}
                    style={{ display: "block", marginTop: 20 }}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">
                            <IconButton
                                onClick={() => setShowPrivacyPassword(!showPrivacyPassword)}
                                edge="end"
                            >
                                {showPrivacyPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                            </IconButton>
                        </InputAdornment>
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={closeDialog} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
                    Close
                </Button>
                <Button onClick={authenticate} variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#18cc69", color: "#FFF" }} disableElevation>
                    Show {loading && <CircularProgress color="inherit" size={14} style={{ marginLeft: 15 }} />}
                </Button>
            </DialogActions>
        </Dialog>
    </div>
}

export default PrivacyPasswordAuthentication